
import React, { FC, useState } from 'react';
import { Button } from 'components/button/Button';
import { QuizFlow } from './QuizFlow';
import { SEO } from 'components/seo/SEO';
import { breadcrumbJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';

import './Quiz.css';

const route = routeManifest.find((r) => r.path === '/quiz')!;
const breadcrumbs = breadcrumbJsonLd([
  { name: 'Home', path: '/' },
  { name: 'Quiz', path: '/quiz' },
]);

export const Quiz: FC = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number | null>(null);

  const quizStartSrc = `${process.env.PUBLIC_URL}/assets/quiz/quiz-start.svg`;

  const startQuiz = () => {
    setCurrentQuestionIndex(0); // go to first question
  };

  const startScreen = <section className='quiz'>
      <h1 className="quiz-title">What toastie are you?</h1>
      <div className="description">
        <p>Find your flavour. Embrace your filling. Because you're more than just a snack — you're a whole toastie.</p>
      </div>
      <img className="quiz-image start" alt='start quiz'
        src={quizStartSrc}
      />
      <Button label="I'm bready to find out" onClick={startQuiz} />
      <p id='personality-text'>A fun personality quiz inspired by MBTI, Cosmos Persona, and Cake</p>
    </section>;

  return (
    <div className="quiz-section">
      <SEO title={route.title} description={route.description} path={route.path} jsonLd={[breadcrumbs]} />
      <div className="quiz-content-container">
      {currentQuestionIndex === null ? (
          startScreen
        ) : (
          <section className='quiz'>
            <QuizFlow />
          </section>
        )}
      </div>
    </div>
  )
}
